<template>
  <div class="bookOrder">
    <div>
      <div class="canteenContent">
        <p>
          {{ canteen.name }}
        </p>
        <p>
          {{ canteen.telephone }}
        </p>
      </div>
      <img src="@/assets/img/banner.jpg" alt="" />
      <van-dropdown-menu class="changeText">
        <van-dropdown-item
          @change="canteenChange"
          title="切换食堂"
          v-model="canteenId"
          :options="canteenList"
        />
      </van-dropdown-menu>
    </div>
    <div style="padding: 0 10px">
      <van-row class="mentSet" align="center" @click="setOrder">
        <van-col span="8">
          <img src="@/assets/img/menuSet.png" alt="" />
        </van-col>
        <van-col span="16">
          <van-row class="text-content">
            <van-col span="24">
              <span>点餐</span>
            </van-col>
            <van-col span="24">
              <span>当日可点今日{{ configData.orderMeal }}</span>
            </van-col>
          </van-row>
        </van-col>
      </van-row>
      <van-row class="mentSet" align="center" @click="reserveOrder">
        <van-col span="8">
          <img src="@/assets/img/reserve.png" alt="" />
        </van-col>
        <van-col span="16">
          <van-row class="text-content">
            <van-col span="24">
              <span>预定</span>
            </van-col>
            <van-col span="24">
              <span>
                最早可订{{ configData.bookDate }}{{ configData.bookMeal }}
              </span>
            </van-col>
          </van-row>
        </van-col>
      </van-row>
    </div>
    <van-row style="background: #f2f2f2; padding: 10px; margin-top: 20px">
      <van-col span="12">
        <span>我的订单</span>
      </van-col>
      <van-col span="12" align="right">
        <span @click="viewAll">查看全部></span>
      </van-col>
    </van-row>
    <van-row
      v-for="item in mealOrderList"
      :key="item.id"
      @click="goDetails(item)"
    >
      <van-row style="width: 100%; padding: 5px 20px">
        <van-col span="12">
          <span>
            {{ $moment(item.reserveDate).format("YYYY-MM-DD") }}
            {{ item.reserveMealName }}
          </span>
        </van-col>
        <van-col style="color: #aaaaaa" span="12" align="right">
          <span>{{ item.statusName }}</span>
        </van-col>
      </van-row>
      <van-row style="width: 100%; padding: 5px 20px">
        <van-col span="12">
          <span> {{ item.businessCateringOrderDetailses.length }}道菜</span>
        </van-col>
        <van-col span="12" align="right">
          <span>￥{{ item.businessPayOrder.price }}</span>
        </van-col>
      </van-row>
      <van-row
        style="width: 100%; padding: 5px 20px; border-bottom: 1px solid #ccc"
      >
        <van-col span="12">
          <p
            style="
              width: 200px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              -o-text-overflow: ellipsis;
              color: #aaaaaa;
            "
          >
            {{ item.dishNames }}
          </p>
        </van-col>
        <van-col span="12" align="right">
          <span style="color: #aaaaaa">
            {{ $moment(item.createTime).format("YYYY-MM-DD HH:mm:ss") }}
          </span>
        </van-col>
      </van-row>
    </van-row>
  </div>
</template>
<script setup>
import {
  requestOrderList,
  canteenSetting,
} from "@/api/orderingFood/orderingFood";
import { queryOpenId } from "@/api/wechat/wechatAuto";
import { reactive, toRefs } from "vue";
import { useRoute, useRouter } from "vue-router";
import { setStorage, getStorage } from "@/utils/common";
const route = useRoute();
const router = useRouter();
const state = reactive({
  orgId: route.params.orgId,
  canteenList: [],
  canteenId: "",
  canteen: "",
  mealOrderList: [],
  configData: {},
});
const {
  canteenList,
  canteen,
  canteenName,
  canteenId,
  mealOrderList,
  configData,
} = toRefs(state);

// 切换食堂
const canteenChange = (val) => {
  const canteenObj = state.canteenList.filter((item) => item.id == val)[0];
  state.canteen = canteenObj;
  console.log(canteenObj);
};
// 获取食堂配制
const queryCanteenSetting = () => {
  canteenSetting({ canteenId: state.canteenId }).then((v) => {
    const { data } = v;
    state.configData = data;
  });
};

// 获取食堂和订单
const queryOrder = () => {
  requestOrderList({ orgId: state.orgId }).then((v) => {
    const { data } = v;
    data.businessCanteenList.forEach((value) => {
      value.text = value.name;
      value.value = value.id;
    });
    state.mealOrderList = data.businessCateringOrderList;
    state.canteenList = data.businessCanteenList;
    state.canteen = data.businessCanteenList[0];
    state.canteenId = data.businessCanteenList[0].id;
    state.orgAddress = data.businessOrg.address;
    queryCanteenSetting();
  });
};
// 点餐
const setOrder = () => {
  router.push({
    name: "mealsList",
    query: {
      canteenId: state.canteenId,
      type: 1,
      orgId: state.orgId,
      orgAddress: state.orgAddress,
      orderMeal: state.configData.orderMeal,
    },
  });
};
// 预定
const reserveOrder = () => {
  router.push({
    name: "reserveList",
    query: {
      canteenId: state.canteenId,
      type: 1,
      orgId: state.orgId,
      orgAddress: state.orgAddress,
      orderMeal: state.configData.orderMeal,
    },
  });
};

// 查看全部
const viewAll = () => {
  router.push({ name: "mealsOrderList" });
};
// 去详情页
const goDetails = (item) => {
  router.push({ name: "mealsOrderDetails", query: { id: item.id } });
};

const queryInfo = () => {
  let pageUrl = `${location.href.split("#")[0]}`;
  window.location.href =
    "https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx6cfd6f1d50ea07ba&redirect_uri=" +
    encodeURIComponent(pageUrl) +
    "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
};
if (!route.query.code) {
  queryInfo();
} else {
  const storageToken = getStorage("wechatToken");
  if (!storageToken) {
    queryOpenId({ code: route.query.code, needToken: 1 }).then((v) => {
      const { data } = v;
      if (data.token) {
        setStorage("wechatToken", data.token);
        queryOrder();
      }
    });
  } else {
    queryOrder();
  }
}
</script>
<style lang="scss" scoped>
.bookOrder {
  .changeText {
    position: absolute;
    right: 2%;
    top: 0;
    ::v-deep .van-dropdown-menu__bar {
      background: transparent !important;
      box-shadow: none;
    }
    ::v-deep .van-dropdown-menu__title {
      border: 1px solid #999;
    }
    ::v-deep .van-dropdown-menu__title::after {
      display: none;
    }
  }
  .canteenContent {
    position: absolute;
    top: 12px;
    left: 10px;
    p {
      font-size: 16px;
    }
    p:last-of-type {
      margin-top: 10px;
    }
  }
  .mentSet {
    background: #066e73;
    border-radius: 10px;
    margin-bottom: 10px;
    padding-left: 20px;
    .text-content {
      .van-col {
        span {
          color: #fff;
        }
      }
      .van-col:first-of-type {
        margin-bottom: 10px;
        span {
          font-size: 21px;
          font-weight: bold;
        }
      }
    }
  }
}
</style>
